(()=>{
  if(window.ktsuGuidesInitialized)return;
  window.ktsuGuidesInitialized=true;
  function prepare(root=document){
    root.querySelectorAll('.ktsu .article-prose table').forEach(table=>{
      if(table.parentElement.classList.contains('table-scroll'))return;
      const wrapper=document.createElement('div');wrapper.className='table-scroll';wrapper.tabIndex=0;wrapper.setAttribute('role','region');wrapper.setAttribute('aria-label','Scrollable article table');table.before(wrapper);wrapper.append(table);
    });
    root.querySelectorAll('.ktsu-article').forEach(article=>{
      const toc=article.querySelector('[data-ktsu-toc]');
      if(!toc||toc.dataset.prepared)return;
      toc.dataset.prepared='true';
      const headings=[...article.querySelectorAll('.article-prose h2')].filter(heading=>heading.textContent.trim());
      if(headings.length<2)return;
      const list=toc.querySelector('[data-ktsu-toc-list]');
      headings.forEach((heading,index)=>{
        if(!heading.id){let id='ktsu-section-'+(index+1);while(document.getElementById(id))id+='-x';heading.id=id;}
        const item=document.createElement('li');const link=document.createElement('a');
        link.href='#'+encodeURIComponent(heading.id);link.textContent=heading.textContent.trim();
        item.append(link);list.append(item);
      });
      toc.querySelector('[data-ktsu-toc-count]').textContent=headings.length+' sections';
      toc.open=headings.length<=8&&window.matchMedia('(min-width:761px)').matches;
      toc.hidden=false;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>prepare());else prepare();
  document.addEventListener('shopify:section:load',event=>prepare(event.target));
})();
